const folderServiceName = '/Folder';

export function folderService (http) {
    return {
        // getSpecificFolderAsync: async folderId => {
        //     let parameters = {
        //         Id: folderId
        //     };

        //     return await http.post(folderServiceName + '/GetSpecificFolderAsync', parameters);
        // },
        // getFoldersByDriveAsync: async driveId => {
        //     let parameters = {
        //         driveId
        //     };

        //     return await http.post(folderServiceName + '/GetFoldersByDriveAsync', parameters);
        // },
        
        getFoldersByParent: async id => {
            let parameters = { id };
            return await http.post(folderServiceName + '/GetFoldersByParent', parameters);
        }


    }
}